"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetContext = exports.useGetConfig = exports.useForrestJS = exports.ForrestJSContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ForrestJSContext = /*#__PURE__*/_react.default.createContext();
/**
 * @returns {any} ForrestJS Context
 */


exports.ForrestJSContext = ForrestJSContext;

var useForrestJS = function useForrestJS() {
  return (0, _react.useContext)(ForrestJSContext);
};
/**
 * @param {String} path
 * @param {any} [defaultValue]
 * @returns {any}
 */


exports.useForrestJS = useForrestJS;

var useGetConfig = function useGetConfig(path, defaultValue) {
  var _useContext = (0, _react.useContext)(ForrestJSContext),
      getConfig = _useContext.getConfig;

  return getConfig(path, defaultValue);
};
/**
 * @param {String} path
 * @param {any} [defaultValue]
 * @returns {any}
 */


exports.useGetConfig = useGetConfig;

var useGetContext = function useGetContext(path, defaultValue) {
  var _useContext2 = (0, _react.useContext)(ForrestJSContext),
      getContext = _useContext2.getContext;

  return getContext(path, defaultValue);
};

exports.useGetContext = useGetContext;